import desktopPng from './treatsDogDesktop.png';
import mobilePng from './treatsDogMobile.png';

export const treatsDogDesktop = [desktopPng];
export const treatsDogMobile = [mobilePng];
